// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.separator {
  display: flex;
  align-items: center;
  text-align: center;
}
.separator::after {
  content: '';
  flex: 12;
  border-bottom: 1px solid #d2d4d3;
}
.separator:not(:empty)::before {
  margin-right: .25em;
}
.separator:not(:empty)::after {
  margin-left: .25em;
}
`, "",{"version":3,"sources":["webpack://./src/main/webapp/ssoreact/loginpages/PageUserInfo.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,QAAQ;EACR,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".separator {\n  display: flex;\n  align-items: center;\n  text-align: center;\n}\n.separator::after {\n  content: '';\n  flex: 12;\n  border-bottom: 1px solid #d2d4d3;\n}\n.separator:not(:empty)::before {\n  margin-right: .25em;\n}\n.separator:not(:empty)::after {\n  margin-left: .25em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
